import { checkDiff } from '../../../../utils/formValidation/errorCheckingFunctions';
import {
    getReqMessage,
    getSameAsMessage
} from '../../../../utils/formValidation/errorMessageFunctions';
import {
    validateDateOfBirth,
    validateEmail,
    validateGender,
    validatePhone,
    validatePostcode,
    validateUniqueIdentifier
} from '../../../../utils/formValidation/validationFunctions';

export const validate = (newEntry, initialStateOnEntry) => {
    let newErrors = {};

    newErrors = validateGender(newEntry.genderId, newErrors);
    newErrors = validateDateOfBirth(newEntry.dateOfBirth, newErrors);
    newErrors = validateUniqueIdentifier(
        newEntry.uniqueIdentifierType,
        newEntry.uniqueIdentifier,
        newEntry.repeatUniqueIdentifier,
        newErrors
    );

    if (!newEntry.address1) {
        newErrors = {
            ...newErrors,
            address1: { error: true, message: getReqMessage('Address1') }
        };
    }

    if (!newEntry.postcode) {
        newErrors = {
            ...newErrors,
            postcode: { error: true, message: getReqMessage('Postcode') }
        };
    } else newErrors = validatePostcode(newEntry.postcode, newErrors);

    newErrors = validatePhone(newEntry.primaryPhoneNumber, newErrors, 'primaryPhoneNumber');

    if (newEntry.secondaryPhoneNumber) {
        if (newEntry.secondaryPhoneNumber === newEntry.primaryPhoneNumber) {
            newErrors = {
                ...newErrors,
                secondaryPhoneNumber: {
                    error: true,
                    message: getSameAsMessage('Primary phone number', 'Secondary phone number')
                }
            };
        } else
            newErrors = validatePhone(
                newEntry.secondaryPhoneNumber,
                newErrors,
                'secondaryPhoneNumber'
            );
    }

    newErrors = validateEmail(newEntry.emailAddress, newErrors);

    if (Object.keys(newErrors).length < 1) newErrors = checkDiff(newEntry, initialStateOnEntry);

    return newErrors;
};
